import React, { Component } from 'react';
import urlHandler from '../../../utils/urlHandler';

class DocCutomEntitiesRetrieve extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Retrieve Custom RegEx</h3>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_REGEX_RETRIEVE}
                </code>
                <div className="description">
                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    <br/>
                    <b>Retrieve Custom RegEx</b><br/>
                    <br/>
                    The retrieve endpoint allows for a user to simply retrieve the list of patterns that are active in real-time. The response can be processed for your own checkpoints, backups, etc as the structure returned can be directly used by the insert, validate, delete RegEx endpoints.         
                </div>
            </div>
        );
    }
}

export default DocCutomEntitiesRetrieve